import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-icon_status_ended",
  "use": "svg-icon-icon_status_ended-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-icon_status_ended\"><g fill=\"none\"><path d=\"M0 0h12v12H0z\" /><rect fill-opacity=\".6\" fill=\"#000\" width=\"12\" height=\"12\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol